import React from 'react';
import './Header.scss';
import MegaMenuEditorialBlock from './MegaMenuEditorialBlock';

const MegaMenuItem = ({ item }) => {
  return (
    <div className="flex flex-col p-4 pt-[13px] pb-[40px] px-[60px]">
      <h2 className='flex mb-10 text-4xl text-[#29588c] font-bold'>
        {item?.linkTitle && (
          <a href={item?.linkUrl} className="underline hover:underline">
            {item.linkTitle}
          </a>
        )}
      </h2>
      <ul className='columns-3 gap-5 pb-10'>
        {item?.editorialBlocks?.map(editorialBlock => (
          <MegaMenuEditorialBlock key={editorialBlock.id} editorialBlock={editorialBlock} />
        ))}
      </ul>
    </div>
  );
};

export default MegaMenuItem;